<template>
  <div id="detailed-list">
    <div class="detailed-list-title">
      <div>对比清单</div>
      <div class="contrast-colse" @click="callBack">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div class="detailed-list-box">
      <div
        class="detailed-list-name"
        v-for="(item, index) in contrastList"
        :key="index"
      >
        <span></span> {{ item.name }}
      </div>
    </div>

    <div class="detailed-list-btn">
      <el-button type="success" @click="contrast">对比</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "detailed-list",
  props: {
    contrastList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    callBack() {
      this.$emit("callBack", false);
    },
    contrast() {
      this.$router.push({ path: "/land/contrast" });
      sessionStorage.setItem("contrastList", JSON.stringify(this.contrastList));
    },
  },
};
</script>
<style scoped>
#detailed-list {
  width: 300px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #c7c3c3;
  box-shadow: 0 0 10px #c7c3c3;
  border-radius: 4px;
}
.detailed-list-box {
  max-height: 400px;
  overflow: auto;
}
.detailed-list-title {
  font-size: 0.95rem;
  color: rgb(34, 34, 34);
  font-weight: 600;
  padding-bottom: 10px;
  line-height: 25px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
.detailed-list-name {
  font-size: 0.85rem;
  color: rgb(90, 90, 90);
  padding: 7px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid #eee;
}
.detailed-list-btn {
  /* display: flex;
  justify-content: flex-end; */
  margin-top: 15px;
}
.contrast-colse {
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  color: #025992;
}
</style>
